import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GroupService } from '../../services/group.service';
import { PlayerService } from '../../services/player.service';

@Component({
  selector: 's18-new-group-dialog',
  templateUrl: './new-group-dialog.component.html',
  styleUrls: ['./new-group-dialog.component.scss']
})
export class NewGroupDialogComponent implements OnInit {
  sendingRequest: boolean = false;
  groupType: number;
  playerId: string;
  name: string;
  startDate: string;
  endDate: string;
  message: string;
  eventDate: string;


  constructor(
    private playerService: PlayerService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<NewGroupDialogComponent>,
    private groupService: GroupService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.groupType = data.groupType;
    this.playerId = data.playerId;
  }

  ngOnInit() {

  }

  isLeagueOrTrip(){
    return +this.groupType === 2 || +this.groupType === 5;
  }

  isOutsideGroup(){
    return +this.groupType === 4;
  }

  createGroup(){
    this.sendingRequest = true;
    if ( this.isOutsideGroup()){
      this.groupService.createGroup(this.playerId, this.name, "4")
        .subscribe( resp => this.processResponse(resp));
    }else if ( this.isLeagueOrTrip()){
      this.groupService.createLeagueOrTrip(this.playerId, this.name, this.groupType.toString(), this.startDate, this.endDate)
        .subscribe( resp => this.processResponse(resp));
    }else if ( !this.isLeagueOrTrip()) {
      this.groupService.createGroup(this.playerId, this.name, "1")
        .subscribe( resp => this.processResponse(resp));
    }
  }

  setEndDate(){
    let startDateValue = Date.parse(this.startDate);
    if ( +this.groupType === 2 ){ //league
      let newEndDate = new Date( startDateValue + 1000*60*60*24*365); //a year
      this.endDate = newEndDate.toISOString().split('T')[0];
    } else if ( +this.groupType === 5){
      let newEndDate = new Date( startDateValue + 1000*60*60*24*14); //14 days
      this.endDate = newEndDate.toISOString().split('T')[0];
    } else if ( +this.groupType === 4){
      let newEndDate = new Date( Date.parse(this.eventDate) + 1000*60*60*24*1); //1 day
      this.endDate = newEndDate.toISOString().split('T')[0];
    }
  }

  processResponse(resp){
    this.sendingRequest = false;
    let groupId = JSON.parse(resp.d).group_id;
    this.playerService.loadAdminGroups(this.playerId);
    this.dialogRef.close(groupId);
  }

  getGroupTypeName(){
    var type = +this.groupType;
    switch (type){
      case 2:
        return 'League';
      case 5:
        return 'Trip';
      case 4:
        return 'Organization';
      default:
        return 'Group';
    }
  }

}
